export interface UpdateRequired {
  minVersion: string | null;
  updateUrl: string | null;
}

export interface AppUpdateState {
  required: UpdateRequired | null;
  availableVersion: string | null;
  storeUrl: string | null;
}

export const dismissedUpdateStorageName = 'dismissedAppUpdateVersion';

const initialState: AppUpdateState = { required: null, availableVersion: null, storeUrl: null };

let state: AppUpdateState = initialState;
const listeners = new Set<() => void>();

const setState = (next: AppUpdateState) => {
  state = next;
  listeners.forEach((listener) => listener());
};

export const getAppUpdateState = () => state;

export const subscribeToAppUpdateState = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const setUpdateRequired = (required: UpdateRequired) => {
  if (state.required) return;
  setState({ ...state, required });
};

export const setUpdateAvailable = (version: string, storeUrl: string | null) => {
  if (state.availableVersion === version || sessionStorage.getItem(dismissedUpdateStorageName) === version) return;
  setState({ ...state, availableVersion: version, storeUrl });
};

export const dismissUpdateAvailable = () => {
  if (state.availableVersion === null) return;
  sessionStorage.setItem(dismissedUpdateStorageName, state.availableVersion);
  setState({ ...state, availableVersion: null });
};

export const resetAppUpdateState = () => setState(initialState);
